// ✅ CLEAN, SORTED, VALID DATA (UNIX seconds)

const sampleData = [
  { time: 1704068100, open: 100, high: 105, low: 98, close: 102 },
  { time: 1704068400, open: 102, high: 108, low: 101, close: 107 },
  { time: 1704068700, open: 107, high: 110, low: 106, close: 108 },
  { time: 1704069000, open: 108, high: 112, low: 107, close: 111 },
  { time: 1704069300, open: 111, high: 115, low: 110, close: 114 },
  { time: 1704069600, open: 114, high: 116, low: 112, close: 113 },
  { time: 1704069900, open: 113, high: 117, low: 111, close: 116 },
  { time: 1704070200, open: 116, high: 120, low: 115, close: 119 },
  { time: 1704070500, open: 119, high: 121, low: 117, close: 118 },
  { time: 1704070800, open: 118, high: 122, low: 116, close: 121 },
];

export default sampleData;